var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('svg', _vm._g({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "width": "24",
      "height": "24",
      "viewBox": "15 15 24 24"
    }
  }, _vm.$listeners), [_c('defs', [_c('filter', {
    attrs: {
      "id": "a",
      "width": "118.5%",
      "height": "198.9%",
      "x": "-9.2%",
      "y": "-45.1%",
      "filterUnits": "objectBoundingBox"
    }
  }, [_c('feOffset', {
    attrs: {
      "dy": ".2",
      "in": "SourceAlpha",
      "result": "shadowOffsetOuter1"
    }
  }), _c('feGaussianBlur', {
    attrs: {
      "in": "shadowOffsetOuter1",
      "result": "shadowBlurOuter1",
      "stdDeviation": "7.5"
    }
  }), _c('feColorMatrix', {
    attrs: {
      "in": "shadowBlurOuter1",
      "result": "shadowMatrixOuter1",
      "values": "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.117706512 0"
    }
  }), _c('feMerge', [_c('feMergeNode', {
    attrs: {
      "in": "shadowMatrixOuter1"
    }
  }), _c('feMergeNode', {
    attrs: {
      "in": "SourceGraphic"
    }
  })], 1)], 1)]), _c('g', {
    attrs: {
      "fill": "#FFF",
      "fill-rule": "evenodd",
      "filter": "url(#a)",
      "transform": "translate(-314 -10)"
    }
  }, [_c('path', {
    attrs: {
      "d": "M341 40.908c-.71 0-1.228-.554-1.228-1.32 0-.763.518-1.318 1.229-1.318.722 0 1.227.542 1.227 1.319 0 .765-.517 1.319-1.227 1.319zm1.027-13.361-.268 9.592h-1.517l-.268-9.592zM330.754 25c-.94 0-1.7.783-1.7 1.748v12.68L329 49l5.36-5.47h16.94c.94 0 1.7-.782 1.7-1.747V26.748c0-.965-.76-1.748-1.7-1.748z"
    }
  })])]);

}
var staticRenderFns = []

export { render, staticRenderFns }